import { Entity } from './base-raptor-models';
import { User } from './user.model';

export interface Notification extends Entity {
    message: string;
    relatedTaskStatus?: NotificationTaskStatus;
    relatedTaskUpdatedOn?: Date;
    status: NotificationStatus;
    title: string;
    type: NotificationType;
    userId: string;
    user?: User;
    /**
     * Discriminator for the deep-link target carried by a {@link NotificationType.CustomerMessage}
     * notification. `'Customer'` pairs with a customer id, `'Phone'` pairs with a normalized phone
     * number for an inbound message that matched no customer. Null for notifications that carry no
     * deep-link target. Mirrors the backend `NotificationOutputMessage.ReferenceType`.
     */
    referenceType?: string;
    /**
     * The deep-link target identifier interpreted according to {@link referenceType} (a customer id
     * or a normalized phone number). Null when the notification carries no deep-link target. Mirrors
     * the backend `NotificationOutputMessage.ReferenceId`.
     */
    referenceId?: string;
}

export enum NotificationTaskStatus {
    Pending = 'Pending',
    Running = 'Running',
    Completed = 'Completed',
    Failed = 'Failed',
}

export enum NotificationStatus {
    New = 'New',
    Read = 'Read',
    Dismissed = 'Dismissed',
}

export enum NotificationType {
    LongRunningTask = 'Long Running Task',
    SystemAlert = 'System Alert',
    UserMessage = 'User Message',
    WorkAssigned = 'Work Assigned',
    WorkApproved = 'Work Approved',
    InspectionReturned = 'Inspection Returned',
    CustomerMessage = 'Customer Message',
}
